"use client"

import { memo } from "react"
import { cn } from "@/lib/utils"

export const AgentAvatar = memo(function AgentAvatar({
  pulse = false,
  theme = 'green'
}: {
  pulse?: boolean
  theme?: 'green' | 'orange' | 'mode'
}) {
  const isOrange = theme === 'orange'
  const isMode = theme === 'mode'

  return (
    <div data-agent-avatar="" className={cn("relative h-7 w-7 shrink-0 mt-0.5", pulse && "animate-bounce-ball")}>
      <div
        className={cn(
          "relative h-full w-full rounded-full shadow-md overflow-hidden ring-1",
          isMode
            ? "ring-[var(--tv2-mode-glow)]"
            : isOrange ? "ring-orange-400/30" : "ring-emerald-400/30"
        )}
        style={
          isMode
            ? {
                background: 'var(--tv2-mode)',
                boxShadow: '0 0 12px var(--tv2-mode-glow)',
                transition: 'background 400ms ease, box-shadow 400ms ease',
              }
            : { background: isOrange
                ? 'linear-gradient(to bottom right, #ea580c, #f97316, #f59e0b)'
                : 'linear-gradient(to bottom right, #059669, #10b981, #34d399)' }
        }
      >
        <svg
          className="absolute inset-0 m-auto h-2.5 w-2.5 text-white/90 drop-shadow-sm"
          viewBox="0 0 16 16"
          fill="currentColor"
          aria-hidden
        >
          <path d="M8 0C8.5 5 11 8 16 8C11 8 8.5 11 8 16C7.5 11 5 8 0 8C5 8 7.5 5 8 0Z" />
        </svg>
      </div>
    </div>
  )
})
